import enviro from 'enviro';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { Realtime } from 'ably';
import { getAblyTokenRequestRpc } from 'personalization-lib/__generated__/chirp/com/hubspot/personalize/rpc/PersonalizeAblyRpc';

/* Helper functions */
const fetchAblyTokenRequest = async () => {
  const rpcClient = createRpcClientV2({
    hubHttpClient: http
  });
  const response = await rpcClient.call(getAblyTokenRequestRpc, {
    request: {}
  });
  return JSON.parse(response.tokenRequestJson);
};
const getDefaultClientOptions = () => {
  const hublet = enviro.getHublet();
  return {
    environment: `hubspot-${hublet}`,
    fallbackHosts: [`hubspot-${hublet}-a-fallback.ably-realtime.com`, `hubspot-${hublet}-b-fallback.ably-realtime.com`, `hubspot-${hublet}-c-fallback.ably-realtime.com`, `hubspot-${hublet}-d-fallback.ably-realtime.com`, `hubspot-${hublet}-e-fallback.ably-realtime.com`]
  };
};

/* Singleton Ably client */
let ablyClient;
export const getAblyClient = () => {
  if (ablyClient) {
    return ablyClient;
  }
  ablyClient = new Realtime(Object.assign({}, getDefaultClientOptions(), {
    authCallback: (__tokenParams, callback) => {
      fetchAblyTokenRequest().then(tokenRequest => callback(null, tokenRequest)).catch(error => callback(error, null));
    },
    autoConnect: true,
    echoMessages: false,
    queryTime: true
  }));
  return ablyClient;
};